var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "status-container" }, [
      _c("p", { staticClass: "title" }, [_vm._v(" 404，联系一下开发者 ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }